export interface SetInitialStateFacade {
  setInitialState: () => void;
}
